// Loading animation

import { ITEMS_PER_PAGE } from '@/app/constants';

const shimmer =
  'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent';

export function ItemSkeleton() {
  return (
    <div className={`${shimmer} relative overflow-hidden rounded-md bg-gray-100 p-2 col`}>
      <div className={` ${shimmer}`}>
        <div style={{ width: 215, height: 287 }} className="d-flex justify-content-center my-3 shimmer-image"></div>
        <div className="mb-1 shimmer-text"></div>
        <div className="mb-1 shimmer-text"></div>
        <div className="mb-1 shimmer-text"></div>
        <div className={`d-flex ${shimmer}`}>
          <div className={`me-2 shimmer-icon ${shimmer}`}></div>
          <div className={`w-50 shimmer-text ${shimmer}`}></div>
        </div>
      </div>
    </div>
  );
}

export function ItemsSkeleton() {
  const itemsToRender = ITEMS_PER_PAGE;
  const items = [];
  for (let i = 0; i < itemsToRender; i++) {
    items.push(<ItemSkeleton key={i} />);
  }
  return <div className={'row row-cols-2 row-cols-md-3 row-cols-lg-5'}>{items}</div>;
}

export function PriceFilterSkeleton() {
  return (
    <div className="row">
      <div id="skeleton" className={` ${shimmer} relative overflow-hidden rounded-md bg-gray-100 p-2`}>
        <div className={` ${shimmer}`}>
          <div className="p-2">
            <div className="d-flex gap-2">
              <div className="w-50">
                <div className="mb-1 shimmer-text w-100" style={{ height: '48px' }}></div>
              </div>
              <span className="d-flex aligncenter">-</span>
              <div className="w-50">
                <div className="mb-1 shimmer-text w-100" style={{ height: '48px' }}></div>
              </div>
            </div>
            <div className="mt-4 d-flex">
              <div className="w-100">
                <div className="mb-1 shimmer-text w-100" style={{ height: '10px' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
